import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import { BootstrapVue } from 'bootstrap-vue'
import { VLazyImagePlugin } from 'v-lazy-image'
import TextareaAutosize from 'vue-textarea-autosize'

Vue.use(BootstrapVue)

Vue.use(VLazyImagePlugin)
Vue.use(TextareaAutosize)

Vue.prototype.moment = moment

//CSS
import './assets/css/vendor/bootstrap/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/vendor/golden-ratio/gr.scss'
import './assets/css/vendor/line-icons/scss/main.scss'
import './assets/css/vendor/float-labels/float-labels.css'
import './assets/css/theme.scss'
import './assets/css/custom.scss'

//config
Vue.config.productionTip = false

//global filters
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
